import { ResponseClientExternalChallenge, RequestClientExternalChallenge } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ClientExternalChallengeActions } from '../actions';
import { ClientExternalChallengeTypes } from '../../shared/enums';

export interface ClientExternalChallengeState {
    response: ResponseClientExternalChallenge;
    request: RequestClientExternalChallenge;
    error: any;
}

export const ClientExternalChallengeInitialState: ClientExternalChallengeState = {
    response: null,
    request: null,
    error: null
};

const _clientExternalChallengeReducer = createReducer(
    ClientExternalChallengeInitialState,

    on(ClientExternalChallengeActions.getClientExternalChallenge, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(ClientExternalChallengeActions.getClientExternalChallengeSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ClientExternalChallengeActions.getClientExternalChallengeError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ClientExternalChallengeActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function clientExternalChallengeReducer(state, action) {
    if (action.type === ClientExternalChallengeTypes.CLIENT_EXTERNAL_CHALLENGE) {
        state = undefined;
    }
    return _clientExternalChallengeReducer(state, action);
}
